
import Tradertype from '@/components/service/newjoin/Tradertype.vue'
export default {
  components: { Tradertype },
  props: {
    result: {
      // 交易商数据
      type: Object,
      default: () => {}
    },
    enterpriseType: {
      // 企业类型--服务商 ServiceProvider = 1交易商 Trader = 2
      type: String,
      default: '2'
    },
    jointradertype: {
      // 加入交易商还是认领交易商类型-1、加入 2、认领 3认证
      type: Number,
      default: 1
    },
    type: {
      // 企业类型-服务商1，交易商2
      type: Number,
      default: 2
    },
    addtradertype: {
      // 1加入还是2认领3认证
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      claimdata: [
        {
          // 认领交易商和服务商选择数据
          index: 0,
          title: this.$v('官方域名验证认领'),
          p: this.$v('将验证文件放置于您所认领域名的根目录下'),
          color: '#BA8434',
          bg: '#FAF5EB',
          icon: 'icon-guanfangyumingyanzhengrenzheng'
        },
        {
          index: 1,
          title: this.$v('邮箱验证认领'),
          p: this.$v('我们会给您的邮箱发送验证码进行验证'),
          color: '#6574E6',
          bg: '#F0F0FC',
          icon: 'icon-qiyeyouxiangyanzhengrenzheng'
        },
        {
          index: 2,
          title: this.$v('官网发文认领'),
          p: this.$v('将指定内容发布至您认领的网站上'),
          color: '#448FFF',
          bg: '#EFF5FE',
          icon: 'icon-guanwangfawenrenzheng'
        },
        {
          index: 3,
          title: this.$v('人工客服认领'),
          p: this.$v('留下您的联系方式，我们会在2个工作日联系您'),
          color: '#45ABCA',
          bg: '#EEF9FB',
          icon: 'icon-rengongkefurenzheng'
        }
      ],
      joindata: [
        {
          // 加入交易商和服务商选择数据
          index: 0,
          title: this.$v('企业邮箱验证加入'),
          p: this.$v('企业邮箱通过验证，即可加入'),
          color: '#BA8434',
          bg: '#FAF5EB',
          icon: 'icon-qiyeyouxiangyanzhengjiaru'
        },
        {
          index: 1,
          title: this.$v('管理员审核加入'),
          p: this.$v('管理员同意，即可加入'),
          color: '#6574E6',
          bg: '#F0F0FC',
          icon: 'icon-guanliyuanshenhejiaru'
        }
      ],
      authendata: [
        {
          // 认证服务商
          index: 0,
          title: this.$v('官方域名验证认证'),
          p: this.$v('将验证文件放置于您所认领域名的根目录下'),
          color: '#BA8434',
          bg: '#FAF5EB',
          icon: 'icon-guanfangyumingyanzhengrenzheng'
        },
        {
          index: 1,
          title: this.$v('邮箱验证认证'),
          p: this.$v('我们会给您的邮箱发送验证码进行验证'),
          color: '#6574E6',
          bg: '#F0F0FC',
          icon: 'icon-qiyeyouxiangyanzhengrenzheng'
        },
        {
          index: 2,
          title: this.$v('官网发文认证'),
          p: this.$v('将指定内容发布至您认领的网站上'),
          color: '#448FFF',
          bg: '#EFF5FE',
          icon: 'icon-guanwangfawenrenzheng'
        },
        {
          index: 3,
          title: this.$v('人工客服认证'),
          p: this.$v('留下您的联系方式，我们会在2个工作日联系您'),
          color: '#45ABCA',
          bg: '#EEF9FB',
          icon: 'icon-rengongkefurenzheng'
        }
      ]
    }
  },
  computed: {
    TradertypeData() {
      let arr = []
      if (this.jointradertype == 1) {
        arr = [...this.joindata]
      } else if (this.jointradertype == 2) {
        arr = [...this.claimdata]
      } else if (this.jointradertype == 3) {
        arr = [...this.authendata]
      }
      return arr
    }
  }
}
